import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full bg-neutral-500 text-center items-center justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-white" }, "Aguarde estamos carregando o chat", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      name: "LoadingCircle",
      size: "90"
    }),
    _hoisted_2
  ]))
}